import { TDeviceFormFactor, TDeviceOS, TDeviceBrowserName } from 'js/hooks/device/store/types';
import { SUPPORTED_BROWSER_NAMES, SUPPORTED_OS } from 'js/hooks/device/store/constants';

import { IGame } from '../../types';
import { IGamesConfigurationResponse, IGamesConfiguration } from './types';

export const filterGamesByAvailability = ({ games, formFactor, os, browserName }: {
    os: TDeviceOS;
    gameCodes: string[];
    formFactor: TDeviceFormFactor;
    browserName: TDeviceBrowserName;
    games: { [key: string]: IGame };
}): { [key: string]: IGame } => {
    return Object.keys(games).reduce((acc, gameCode) => {
        const game = games[gameCode];

        if (
            /* eslint-disable @typescript-eslint/no-extra-parens */
            game.deviceAvailability.includes(formFactor) &&
            (game.browserAvailability.includes(browserName) || (!SUPPORTED_BROWSER_NAMES.includes(browserName) && game.browserAvailability?.includes('other'))) &&
            (game.osAvailability.includes(os) || (!SUPPORTED_OS.includes(os) && game.osAvailability.includes('other')))
            /* eslint-enable @typescript-eslint/no-extra-parens */
        ) {
            acc[gameCode] = games[gameCode];
        }

        return acc;
    }, {} as { [key: string]: IGame });
};

export const parseGamesConfigurationResponse = ({ response, formFactor, os, browserName }: {
    os: TDeviceOS;
    formFactor: TDeviceFormFactor;
    browserName: TDeviceBrowserName;
    response: IGamesConfigurationResponse;
}): IGamesConfiguration => {
    const { gameTileLayouts, gameInfoLayouts, games, ...other } = response;

    const basicGameTileLayout = gameTileLayouts[`${formFactor}BasicGameTileLayout`];
    const liveGameTileLayout = gameTileLayouts[`${formFactor}LiveGameTileLayout`];
    const basicGameInfoLayout = gameInfoLayouts[`${formFactor}BasicGameInfoLayout`];
    const liveGameInfoLayout = gameInfoLayouts[`${formFactor}LiveGameInfoLayout`];
    const filteredGames = filterGamesByAvailability({ gameCodes: Object.keys(games), games, formFactor, os, browserName });

    return {
        ...other,
        games: filteredGames,
        basicGameTileLayout,
        liveGameTileLayout,
        basicGameInfoLayout,
        liveGameInfoLayout
    };
};
